import { useCallback, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import { useNavigate, useParams } from "react-router-dom";
import { useImmer } from "use-immer";
import {
  ApiException,
  ManagerClient,
  StoreTypeBudgetMultiplier,
} from "../../../services/ApiClient";
import { NoCards } from "../../layouts/NoCards";
import { BudgetMultiplierForm } from "./BudgetMultiplierForm";
import "./PortalSettings.scss";

interface IBudgetMultiplierNewProps {}

export const BudgetMultiplierNew = (props: IBudgetMultiplierNewProps) => {
  const params = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<null | string>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [multiplierData, setMultiplierData] =
    useImmer<StoreTypeBudgetMultiplier | null>(null);

  useEffect(() => {
    const newMultiplier = {
      from: "",
      id: 0,
      ordertype: 0,
      pctIncrease: 0,
      storeType: 0,
      to: "",
    };

    setMultiplierData(newMultiplier);
  }, [params, setMultiplierData]);

  //Updates all availability data inluding store types that exists on the top level DTO.
  const saveItem = useCallback(
    async (multiplierData: StoreTypeBudgetMultiplier) => {
      try {
        setIsSaving(true);

        await new ManagerClient(
          process.env.REACT_APP_API_BASE
        ).addStoreTypeBudgetMultiplier(multiplierData);

        setIsSaving(false);
        navigate("/settings");
      } catch (e: unknown) {
        const error = e as ApiException;
        console.log(error.message);
        setError(JSON.parse(error.response).error);
      }
    },
    [navigate]
  );

  return (
    <div className={"portal-settings"}>
      <NoCards pageTitle="">
        <>
          <Col md={12}>
            <h3>New multiplier</h3>
          </Col>
          <Col lg={12}>
            <Card className="shadow-sm p-0" border="light">
              <Card.Body className="p-0 portal-settings-form">
                {typeof multiplierData !== "undefined" && multiplierData && (
                  <BudgetMultiplierForm
                    budgetMultiplier={multiplierData}
                    updateBudgetMultiplier={saveItem}
                    isNew={true}
                    isSaving={isSaving}
                  />
                )}
              </Card.Body>
            </Card>
          </Col>
        </>
      </NoCards>
      <Modal show={error?.length! > 0} onHide={() => setError(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{error}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setError(null)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
